import React from 'react';

export const defaultProps = {
  seoTitle: 'Blog >> Solid knowledge on networking & cloud | CodiLime',
  seoDescription:
    'Stay up to date on the latest networking and cloud solutions. Our blog covers the most interesting cases and technologies we deal with.',
  headerTitle: 'Blog',
  headerDescription: (
    <>
      Everything you wanted to know about networking and cloud&nbsp;
      <br /> but you were afraid to ask
    </>
  ),
  headerId: 'blog_header',
  headerImg: 'header-blog.jpg',
};
